module.exports = __webpack_public_path__ + "img/0Q3A3494_L.115ddb68.webp";